export default {
  title: '舆情大数据',
  icon: 'rss',
  path: 'http://yq.gsdata.cn',
  hideSub: true,
  children: (pre => [
    { path: `http://yq.gsdata.cn`, title: '舆情系统', icon: 'dot-circle-o' },
    { path: `http://yuqing.gsdata.cn/vindex/presentationCenter`, title: '舆情报告', icon: 'dot-circle-o' }
  ])('/yq/')
}
